// @flow

import * as React from 'react'
import moment from 'moment'
// $FlowFixMe
import 'moment/locale/it'
import { Button, Modal, Loader, Dimmer } from 'semantic-ui-react'
import DownloadXLSX from '../systemwide/download-xlsx'

import type { DailyDetailsObjectList, ChartSampling } from '../store/reports'

type Props = {|
  selectedDay: string,
  modalLoading: string,
  selectedDayDetails: DailyDetailsObjectList,
  handleClose: () => void,
  showWeb: boolean,
  showF2F: boolean,
  showPhone: boolean,
  sampling: ChartSampling,
|}

class MonthlyModal extends React.Component<Props> {
  renderDetails = (canale: 'WEB' | 'PHONE' | 'F2F') => {
    if (!canale) return []
    let data = this.props.selectedDayDetails[canale]
    if (typeof data === 'undefined') return []
    let details = []
    let color
    switch (canale) {
      case 'F2F':
        color = 'green'
        break
      case 'PHONE':
        color = 'orange'
        break
      default:
        color = 'blue'
    }
    details.push(
      <tr className="active" key={'row-' + canale}>
        <td colSpan="8">
          <div className={'ui ' + color + ' ribbon label'}>{canale}</div>
        </td>
      </tr>
    )
    for (let v of data) {
      details.push(
        <tr key={`row-${v.id_medico}-${v.data_visita}`}>
          <td>{v.cognome + ' ' + v.nome}</td>
          <td className="center aligned">{v.id_medico}</td>
          <td className="center aligned">{v.data_visita}</td>
          <td className="center aligned">{v.prodotto}</td>
          <td className="center aligned">{v.canale}</td>
          <td className="center aligned">{v.area}</td>
          <td className="center aligned">{v.isf}</td>
          <td className="center aligned">{v.call_experience}</td>
        </tr>
      )
    }
    return details
  }

  render() {
    let exportData = Array.prototype.concat(
      this.props.selectedDayDetails['WEB'] || [],
      this.props.selectedDayDetails['F2F'] || [],
      this.props.selectedDayDetails['PHONE'] || []
    )

    let start = moment(this.props.selectedDay)
    let title = 'Dettalio visite '
    if (this.props.sampling === 'DAILY') {
      title += `del giorno ${start.format('DD MMMM YYYY')}`
    } else if (this.props.sampling === 'WEEKLY') {
      title += `dal ${start.format('DD MMMM YYYY')} al ${start.endOf('isoweek').format('DD MMMM YYYY')}`
    } else if (this.props.sampling === 'MONTHLY') {
      title += `dal ${start.format('DD MMMM YYYY')} al ${start.endOf('month').format('DD MMMM YYYY')}`
    }

    return (
      <Modal open={this.props.selectedDay !== ''} size="large">
        <Modal.Header>
          <h4>{title}</h4>
        </Modal.Header>
        <Dimmer.Dimmable
          as={Modal.Content}
          scrolling
          style={{ height: '85vh', backgroundColor: '#F3F4F5' }}
          dimmed={this.props.modalLoading === 'NEW' || this.props.modalLoading === 'PENDING'}
          className="main-container">
          <Dimmer
            active={this.props.modalLoading === 'NEW' || this.props.modalLoading === 'PENDING'}
            inverted
            style={{ zIndex: 700 }}>
            {this.props.modalLoading === 'PENDING' && <Loader />}
          </Dimmer>
          <table
            className="ui compact structured celled selectable blue small table"
            style={{ width: '95%', margin: 'auto', marginBottom: '2rem' }}>
            <thead className="full-width">
              <tr>
                <th className="three wide left aligned">Nominativo</th>
                <th className="two wide center aligned">ID medico</th>
                <th className="two wide center aligned">Data Visita</th>
                <th className="two wide center aligned">Prodotto</th>
                <th className="one wide center aligned">Canale</th>
                <th className="two wide center aligned">Area</th>
                <th className="two wide center aligned">ISF</th>
                <th className="two wide center aligned">Call exp.</th>
              </tr>
            </thead>
            <tbody>
              {this.props.showWeb && this.renderDetails('WEB')}
              {this.props.showF2F && this.renderDetails('F2F')}
              {this.props.showPhone && this.renderDetails('PHONE')}
            </tbody>
          </table>
        </Dimmer.Dimmable>
        <Modal.Actions>
          <DownloadXLSX
            size="small"
            style={{ minWidth: '20ex', marginLeft: '2ex' }}
            icon="download"
            color="orange"
            label="Esporta"
            labelPosition="left"
            filename={`dettaglio_visite_${this.props.selectedDay}.xlsx`}
            sheetname="export"
            data={exportData}
            mode="button"
          />
          <Button
            size="small"
            style={{ minWidth: '20ex' }}
            onClick={this.props.handleClose}
            icon="close"
            labelPosition="left"
            primary
            content="Chiudi"
          />
        </Modal.Actions>
      </Modal>
    )
  }
}
export default MonthlyModal



// WEBPACK FOOTER //
// ./src/reports/monthly-modal.js